import { Link } from "react-router";
import { useT } from "../lib/use-t";

export function NotFoundPage() {
  const t = useT();
  return (
    <div className="min-h-dvh flex items-center justify-center px-5">
      <div className="text-center space-y-4">
        <p className="font-mono-badge text-xs uppercase tracking-wider text-[var(--ink-faint)]">
          {t("chrome.common.notFound404")}
        </p>
        <h1 className="text-2xl font-semibold tracking-tight">{t("notFound.title")}</h1>
        <Link
          to="/"
          className="inline-flex rounded-md border border-[var(--border)] px-4 py-2 text-sm hover:bg-panel-soft"
        >
          ← {t("notFound.backToHome")}
        </Link>
      </div>
    </div>
  );
}
